export default {};

const materialFields = ({ labelKey = 'label', valueKey = 'value' } = {}) => [{
  [labelKey]: 'Material Usage',
  [valueKey]: 'materialUsage',
  type: 'table - Materials',
},
{
  [labelKey]: 'Material Usage Transaction Type',
  [valueKey]: 'materialUsageTransactionType',
  type: 'input',
},
{
  [labelKey]: 'Material Usage Document Type',
  [valueKey]: 'materialUsageDocumentType',
  type: 'input',
},
{
  [labelKey]: 'Material Usage Distribution Type',
  [valueKey]: 'materialUsageDistributionType',
  type: 'input',
},
{
  [labelKey]: 'Material Transfer',
  [valueKey]: 'materialTransfer',
  type: 'table - Materials',
},
{
  [labelKey]: 'Material Transfer Transaction Type',
  [valueKey]: 'materialTransferTransactionType',
  type: 'input',
},
{
  [labelKey]: 'Material Transfer Document Type',
  [valueKey]: 'materialTransferDocumentType',
  type: 'input',
},
{
  [labelKey]: 'Material Transfer Distribution Type',
  [valueKey]: 'materialTransferDistributionType',
  type: 'input',
}];

export const CUSTOM_MAPPINGS_KEY = 'customMappings';
export const CUSTOM_MAPPING_FIELD_TYPES = ['text', 'dropdown', 'attribute', 'hours'];

export const RESERVED_MAPPING_KEYS = new Set([
  'payCodeMappings',
  'overrides',
  CUSTOM_MAPPINGS_KEY,
  'job',
  'cost_code',
]);

export const eclipseTimeFields = [
  {
    label: 'Date',
    value: 'timecard_date',
    required: true,
    type: 'clock',
  },
  {
    label: 'Regular Hours',
    value: 'rt_hours',
    type: 'hours',
  },
  {
    label: 'Overtime Hours',
    value: 'th_hours',
    type: 'hours',
  },
  {
    label: 'Double Time Hours',
    value: 'dt_hours',
    type: 'hours',
  },
  {
    label: 'Union Code',
    value: 'union_code',
    type: 'union',
  },
  {
    label: 'Work Classifcation',
    value: 'work_class',
    type: 'union',
  },
  {
    label: 'Travel Time',
    value: 'tt_hours',
    type: 'text',
  },
  {
    label: 'Notes',
    value: 'notes',
    type: 'text',
  },
  {
    label: 'Foreman Employee Code',
    value: 'foreman',
    type: 'dropdown - Users',
  },
  {
    label: 'Equipment',
    value: 'equipment',
    type: 'table - Equipment',
  },
  ...materialFields(),
  {
    label: 'Pay Code',
    value: 'pay_code',
    type: 'dropdown - Custom',
  },
  {
    label: 'Work Order Number',
    value: 'wo_number',
    types: ['text', 'dropdown'],
  },
];

eclipseTimeFields.forEach((field) => {
  RESERVED_MAPPING_KEYS.add(field.value.toLowerCase());
});

export const ontraccrTimeFields = {
  hours: [
    {
      value: 'totalHours',
      label: 'Total Work Hours',
    },
    {
      value: 'regularHours',
      label: 'Regular Hours',
    },
    {
      value: 'overtimeHours',
      label: 'Overtime Hours',
    },
    {
      value: 'doubleOvertimeHours',
      label: 'Double Overtime Hours',
    },
    {
      value: 'ptoHours',
      label: 'PTO Hours',
    },
  ],
  clock: [{
    value: 'startTime',
    label: 'Start Date',
  }, {
    value: 'endTime',
    label: 'End Date',
  }],
  text: [{
    value: 'note',
    label: 'Notes',
  }],
  union: [{
    label: 'Union',
    value: 'union',
  }, {
    label: 'Union Local',
    value: 'unionLocal',
  }, {
    label: 'Work Classification',
    value: 'unionClass',
  }],
};

export const getEclipseWorkflowSyncFields = (t) => ([
  {
    text: 'Date',
    key: 'timecard_date',
    types: ['dateTime', 'table - TimeEntry'],
  },
  {
    text: t('Project'),
    key: 'job',
    types: ['dropdown - Projects', 'table - TimeEntry'],
  },
  {
    text: 'Cost Code',
    key: 'cost_code',
    types: ['dropdown - Costcodes', 'table - TimeEntry'],
  },
  {
    text: 'Equipment',
    key: 'equipment',
    types: ['table - Equipment'],
  },
  {
    text: 'Work Order Number',
    key: 'wo_number',
    types: ['text', 'dropdown'],
  },
  ...materialFields({ labelKey: 'text', valueKey: 'key' }),
]);
